export function handleError(error: any) {
  const { funcao, arquivo } = obterDetalhesFuncao();

  if (typeof window !== 'undefined') {
    if (window.location.href.includes('localhost')) {
      console.log(`\n ❌ ---------------- \n`);
      console.log(`🎯 LOCAL: ${arquivo} \n`);
      console.log(`🎯 FUNÇÃO: ${funcao} \n`);
      console.log(error);
      console.log('----------------------------');
    }

    return;
  }

  console.log(`\n ❌ - Ops... veja isso \n`);

  console.log(`🎯 LOCAL: ${arquivo} \n`);
  console.log(`🎯 FUNÇÃO: ${funcao} \n`);

  console.log(`👇 mensagem \n`);
  console.log(error);
  console.log(`\n`);
}

function obterDetalhesFuncao() {
  const e = new Error();
  const stackLines = e.stack!.split('\n');
  const callerLine = stackLines[3];
  const regex = /at (\S+) \((?:.*\/)?src\/(.*):\d+:\d+\)/i;
  const match = regex.exec(callerLine!);

  return match
    ? { funcao: match[1], arquivo: 'src/' + match[2] }
    : { funcao: 'Desconhecido', arquivo: 'Desconhecido' };
}
